import type theme from '#build/ui/select'
import type { DeepPartial } from '@nuxt/ui'
import { defu } from 'defu'
import { inputCompoundVariants, inputDefaultVariants, inputSlots, inputVariants } from './input'

export const selectSlots = {
  placeholder: 'text-cvt-cloud-800',
  arrow: 'fill-cvt-cloud-800',
  content: 'bg-cvt-cloud-200 shadow-md ring-1 ring-cvt-cloud-800 rounded-sm',
  viewport: 'divide-cvt-cloud-800',
  empty: 'text-cvt-cloud-800',
  label: 'text-cvt-text-black',
  separator: 'bg-cvt-cloud-800',
  item: 'data-highlighted:not-data-disabled:text-cvt-purple-800 data-highlighted:not-data-disabled:font-semibold data-highlighted:not-data-disabled:before:bg-cvt-cloud-500/50 text-cvt-text-black',
  itemLeadingIcon: 'text-cvt-cloud-800 group-data-highlighted:not-group-data-disabled:text-cvt-text-black',
}

export const selectVariants = {
  color: {
    neutral: {
      value: 'group-data-placeholder:text-cvt-cloud-800',
    },
    error: {
      value: 'group-data-placeholder:text-cvt-burgundy-600',
    },
  },
  size: {
    xs: {
      label: 'gap-1 p-1 text-[10px]/3',
      item: 'gap-1 p-1 text-xs',
      itemLeadingIcon: 'size-4',
      itemLeadingAvatarSize: '3xs',
      itemLeadingChip: 'size-4',
      itemLeadingChipSize: 'sm',
      itemTrailingIcon: 'size-4',
    },
    sm: {
      label: 'gap-1.5 p-1.5 text-[10px]/3',
      item: 'gap-1.5 p-1.5 text-xs',
      itemLeadingIcon: 'size-4',
      itemLeadingAvatarSize: '3xs',
      itemLeadingChip: 'size-4',
      itemLeadingChipSize: 'sm',
      itemTrailingIcon: 'size-4',
    },
    md: {
      base: 'gap-1.5 px-3 py-2 text-xs',
      label: 'gap-1.5 p-1.5 text-xs',
      item: 'gap-1.5 p-1.5 text-sm',
      itemLeadingIcon: 'size-5',
      itemLeadingAvatarSize: '2xs',
      itemLeadingChip: 'size-5',
      itemLeadingChipSize: 'md',
      itemTrailingIcon: 'size-5',
    },
    lg: {
      label: 'gap-2 p-2 text-base',
      item: 'gap-2 p-2 text-base',
      value: 'text-base',
      itemLeadingIcon: 'size-5',
      itemLeadingAvatarSize: '2xs',
      itemLeadingChip: 'size-5',
      itemLeadingChipSize: 'md',
      itemTrailingIcon: 'size-5',
    },
    xl: {
      label: 'gap-2 p-2 text-sm',
      item: 'gap-2 p-2 text-base',
      itemLeadingIcon: 'size-6',
      itemLeadingAvatarSize: 'xs',
      itemLeadingChip: 'size-6',
      itemLeadingChipSize: 'lg',
      itemTrailingIcon: 'size-6',
    },
  },
}

export const selectMergedSlots = defu(selectSlots, inputSlots)
export const selectMergedVariants = defu(selectVariants, inputVariants)

const select: DeepPartial<typeof theme> = {
  slots: { ...selectMergedSlots as any },
  variants: { ...selectMergedVariants as any },
  compoundVariants: [...inputCompoundVariants as any],
  defaultVariants: inputDefaultVariants as any,
}

export default select
